import { createFileRoute } from '@tanstack/react-router';
import { InvitationAcceptanceWizard } from '@/features/invitation-wizard/InvitationAcceptanceWizard';

export const Route = createFileRoute('/invitations/$id/accept')({
  component: InvitationAcceptPage,
  staticData: { authorize: true, requiresAccount: false },
});

function InvitationAcceptPage() {
  const { id } = Route.useParams();
  return <InvitationAcceptanceWizard invitationId={Number(id)} />;
}
